export const STORAGE_KEY = 'SPLITIO_CACHE';
export const IN_MEMORY_CACHE = Symbol('inMemoryCache');
//# sourceMappingURL=consts.js.map